// core/hooks/useFingerprint.ts
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  accessTokenSelector,
  isAuthLoadingSelector,
  jwtSelector,
  userRoleSelector,
} from '@chegg-wt/core/state/user/selectors'
import { Config } from '@chegg-wt/core/config'
import { Cookies, getCookie } from '@chegg-wt/core/utils/cookies'
import { setEnv, getDeviceId, Environment } from '@chegg/fingerprint-web-sdk'

export const useDeviceID = () => {
  const { cheggUserUuid } = useSelector(jwtSelector) || {}
  const userRole = useSelector(userRoleSelector)
  const isLoad = useSelector(isAuthLoadingSelector)
  const idToken = useSelector(accessTokenSelector)
  useEffect(() => {
    const initializeDeviceId = async () => {
      if (cheggUserUuid) {
        if (Config.cheggEnv === 'test') {
          setEnv(Environment.test)
        }
        const combinedUuidSessionId = cheggUserUuid + getCookie(Cookies.CSessionID)
        const combinedUuidUvn = cheggUserUuid + getCookie(Cookies.sdsat_uvn)
        const combinedUuidUvnSessionid =
          cheggUserUuid + getCookie(Cookies.CSessionID) + getCookie(Cookies.sdsat_uvn)
        await getDeviceId({
          userUuid: cheggUserUuid,
          hasSubscription: true,
          cookieDomain: Config.cookieDomain,
          platform: 'WEB',
          combined_uuid_sessionId: combinedUuidSessionId,
          combined_uuid_uvn: combinedUuidUvn,
          combined_uuid_uvn_sessionid: combinedUuidUvnSessionid,
        })
      }
    }
    initializeDeviceId()
  }, [cheggUserUuid, userRole, isLoad, idToken])
}
